import React from 'react';
import { Paper } from '@mui/material';
import { jobOpeningDetailsTabs } from '../../../../../../utils/types/JobOpenings';

interface IJobOpeningContentAreaProps {
  currentTab: jobOpeningDetailsTabs;
  children: React.ReactNode;
}

export const JobOpeningContentArea = ({
  currentTab,
  children,
}: IJobOpeningContentAreaProps) => {
  const isJobPostingTab = currentTab === 'Job Posting';

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        minWidth: 0,
        p: isJobPostingTab ? 1 : { xs: 1.5, sm: 2 },
        boxSizing: 'border-box',
        overflowY: 'auto',
        bgcolor: '#ffffff',
        borderRadius: 2,
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        minHeight: 360,
        maxHeight: 'calc(100vh - 220px)',
        '&::-webkit-scrollbar': {
          width: 6,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#cbd5e1',
          borderRadius: 3,
        },
      }}
    >
      {children}
    </Paper>
  );
};
